import { BottomNav } from "../components/BottomNav";
import { BrandHeader } from "../components/BrandHeader";
import type { RouteView } from "../hooks/useHashRoute";
import type { UiBriefing } from "../types";

export function SourcesView({ briefing, onNavigate, onSettings, onBrandTap }: { briefing: UiBriefing; onNavigate: (view: RouteView) => void; onSettings: () => void; onBrandTap: () => void }) {
  return (
    <>
      <BrandHeader onSettings={onSettings} onBrandTap={onBrandTap} />
      <main className="screen screen--with-nav utility-screen" id="main-content">
        <h1>Source profiles</h1>
        <p className="page-intro">Publication metadata is displayed separately from measured article behavior.</p>
        <div className="source-list">
          {briefing.sources.map((source) => (
            <article key={source.id}>
              <header><h2>{source.name}</h2><span>{source.country}</span></header>
              <dl><div><dt>Type</dt><dd>{source.type}</dd></div><div><dt>Ownership</dt><dd>{source.ownership}</dd></div><div><dt>Orientation</dt><dd>{source.orientation.label ?? "Not entered"}</dd></div></dl>
              {source.orientation.label ? <p>Rating source: {source.orientation.source} · {source.orientation.lastReviewed}</p> : <p>No orientation is shown without a named rating source, methodology, and review date.</p>}
            </article>
          ))}
        </div>
      </main>
      <BottomNav selected="sources" onNavigate={onNavigate} />
    </>
  );
}
